import React, { Component } from 'react';

const STORAGE_KEY = 'fs_cookie_notice_dismissed';

export default class CookieNotice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: localStorage.getItem(STORAGE_KEY) !== '1',
    };
  }

  dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    this.setState({ visible: false });
  };

  render() {
    if (!this.state.visible) return null;
    return (
      <div
        role="dialog"
        aria-label="Cookie notice"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1050,
          backgroundColor: 'rgba(13, 17, 23, 0.97)',
          borderTop: '1px solid rgba(255,255,255,0.12)',
          backdropFilter: 'blur(6px)',
          padding: '0.85rem 1.25rem',
        }}
      >
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2" style={{ maxWidth: '900px', margin: '0 auto' }}>
          <p className="mb-0 text-secondary small">
            This site uses only <strong className="text-light">strictly necessary cookies</strong>: a short-lived session token required for admin access. No tracking, no advertising, no analytics.{' '}
            <a href="/privacy" className="text-info text-decoration-none">Privacy Policy</a>
          </p>
          <button
            onClick={this.dismiss}
            className="btn btn-outline-secondary btn-sm flex-shrink-0"
            aria-label="Dismiss cookie notice"
          >
            Got it
          </button>
        </div>
      </div>
    );
  }
}
